import Vue from 'vue'
import container2Component from './container2/index.vue'
Vue.component('container2', container2Component);